// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import ElementUI from 'element-ui';
import VueCodemirror from 'vue-codemirror';
import VueClipboard from 'vue-clipboard2';
import VueQrCode from '@xkeshi/vue-qrcode';
// import ScrollsPy from 'vue2-scrollspy/dist/index';
import VueQuillEditor from 'vue-quill-editor';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import 'animate.css';
import 'element-ui/lib/theme-chalk/index.css';
import 'codemirror/lib/codemirror.css';
import 'Assets/scss/reset.scss';
import 'Assets/scss/global.scss';
import 'Assets/scss/_mixins.scss';
import 'Assets/scss/_variables.scss';
import 'Assets/scss/_functions.scss';
import 'Assets/iconfont/iconfont.css';
import Plugin from 'Utils/plugin';
import interceptors from 'Api/interceptors';
import Request from 'Api/request';
import router from './router';
import store from './store';
import App from './App';
import Seo from './seo';

Vue.use(ElementUI);
Vue.use(Plugin);
Vue.use(Seo);
// Vue.use(ScrollsPy);
Vue.use(VueQuillEditor);
Vue.use(VueCodemirror);
Vue.use(VueClipboard);
Vue.component('qrcode', VueQrCode);
Vue.config.productionTip = false;
global.Request = Request;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  interceptors,
  template: '<App/>',
  components: { App },
});



// WEBPACK FOOTER //
// ./src/main.js